/**
 * Promo bar countdown.
 * Reads `data-ends-at` (ISO datetime) on the host element and updates
 * descendant `[data-countdown-h]`, `[data-countdown-m]`, `[data-countdown-s]`
 * once per second. If the date is missing or in the past, removes the
 * `[data-countdown-segment]` block entirely (and its preceding dot).
 */
class PromoBar extends HTMLElement {
  connectedCallback() {
    const ends = this.dataset.endsAt;
    this.segment = this.querySelector("[data-countdown-segment]");
    this.h = this.querySelector("[data-countdown-h]");
    this.m = this.querySelector("[data-countdown-m]");
    this.s = this.querySelector("[data-countdown-s]");

    if (!ends || !this.segment || !this.h || !this.m || !this.s) {
      this.#removeSegment();
      return;
    }

    const target = Date.parse(ends);
    if (Number.isNaN(target) || target <= Date.now()) {
      this.#removeSegment();
      return;
    }

    this.target = target;
    this.#tick();
    this.interval = setInterval(() => this.#tick(), 1000);
  }

  disconnectedCallback() {
    if (this.interval) clearInterval(this.interval);
  }

  #tick() {
    const ms = this.target - Date.now();
    if (ms <= 0) {
      this.#removeSegment();
      clearInterval(this.interval);
      return;
    }
    const total = Math.floor(ms / 1000);
    const h = Math.floor(total / 3600);
    const m = Math.floor((total % 3600) / 60);
    const s = total % 60;
    this.h.textContent = String(h).padStart(2, "0");
    this.m.textContent = String(m).padStart(2, "0");
    this.s.textContent = String(s).padStart(2, "0");
  }

  #removeSegment() {
    if (!this.segment) return;
    const prevDot = this.segment.previousElementSibling;
    if (prevDot?.classList.contains("dot")) prevDot.remove();
    this.segment.remove();
  }
}

customElements.define("promo-bar", PromoBar);

export { PromoBar };
